import React from 'react';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { Hook } from './components/Hook';
import { Benefits } from './components/Benefits';
import { Modules } from './components/Modules';
import { Gallery } from './components/Gallery';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-caramel/30 selection:text-espresso" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBadges data-id="element-2" />
      <Hook data-id="element-3" />
      <Benefits data-id="element-4" />
      <Modules data-id="element-5" />
      <Gallery data-id="element-6" />
      <Offer data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
      <StickyCTA data-id="element-10" />
    </div>;
}